import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AppConfig } from "../../app.config";
import { GroupInterface } from "../../interfaces/groupInterface";
import { GroupsResponse } from "../../interfaces/groupsResponse";
import { UserInterfaceResponse } from "../../interfaces/userInterfaceResponse";
import { BehaviorSubject } from "rxjs";
import { UserInterface } from "../../interfaces/userInterface";


@Injectable({
  providedIn: 'root'
})
export class AccessProfileService {

    apiVersion = `v${AppConfig.data['apiVersion']}`;
    service = AppConfig.data['services']['auth'];
    endpoint = `${this.service}/${this.apiVersion}`

    deleteUser = new BehaviorSubject<UserInterface>(null);
    userInfo = this.deleteUser.asObservable()

    constructor(private http: HttpClient){

    }

    createGroup(value: any) {
        if(value.id){
            return this.http.put<GroupInterface>(`${this.endpoint}/groups/${value.id}`, value)
        }else {
            return this.http.post<GroupInterface>(`${this.endpoint}/groups`, value)
        }
    }

    editGroup(id: string, data){
        return this.http.put<GroupInterface>(`${this.endpoint}/groups/${id}`, data)
    }

    deleteGroup(id: string) {
        let params = {
            force: 'true'
        }
        return this.http.delete<any>(`${this.endpoint}/groups/${id}`,{params})
    }

    getGroups(params?){
        return this.http.get<GroupsResponse>(`${this.endpoint}/groups`, {params})
    }

    getAllGroups(params?){
      return this.http.get<GroupsResponse>(`${this.endpoint}/groups`, {params})
  }

    getGroup(id:string){
        return this.http.get<GroupInterface>(`${this.endpoint}/groups/${id}`)
    }

    getCodedFixedGroup(id: string, status: string){
        return this.http.get<GroupInterface>(`${this.endpoint}/groups/${id}/${status}`)
    }

    getUsers(id, filters) {
        return this.http.get<UserInterfaceResponse>(`${this.endpoint}/groups/${id}/users`, {params: filters})
    }

    getUsersOutOfGroup(id, filters) {
        return this.http.get<UserInterfaceResponse>(`${this.endpoint}/groups/${id}/users/out`, {params: filters})
    }

    removeUserFromGroup(id:string, user:string){
        return this.http.delete<any>(`${this.endpoint}/groups/${id}/remove/${user}`)
    }

    addUserToGroup(id: string, users: Array<string>){
        return this.http.put<any>(`${this.endpoint}/groups/${id}/add`,users)
    }

    deleteFromGroup(){

        return this.deleteUser
    }
}
